import * as UserNotificationStore from '../../store/UserNotificationStore';
import * as React from 'react';
import * as UserStore from '../../store/UserStore';
import * as signalR from "@microsoft/signalr";
import CloseIcon from '../../images/dynamicIcons/closeIcon';
import { ApiUrls } from '../../constants/apiUrls';
import { ApplicationState } from '../../store';
import { UserNotification } from '../../models/UserNotificationModels';
import { UserImportantNotification } from './components/UserImportantNotification';
import { connect } from 'react-redux';

const dispatchAction = {
    ...UserNotificationStore.actionCreators,
}

type UserNotificationContainerProps =
    UserNotificationStore.UserNotificationState &
    UserStore.UserState &
    typeof dispatchAction;

interface UserNotificationContainerState {
    hubConnection: signalR.HubConnection | null;
}



class UserNotificationContainer extends React.PureComponent<UserNotificationContainerProps, UserNotificationContainerState> {

    constructor(props: UserNotificationContainerProps) {
        super(props);

        this.state = {
            hubConnection: null
        };
    }



    async componentDidMount() {
        await this.props.InitUserNotificationAction();
        await this.props.GetImportantNotificationAction();
        await this.ConnectHub();


    }

    async componentWillUnmount() {
        await this.props.UnMountUserNotificationAction();

    }



    private async ConnectHub() {
        if (this.state.hubConnection === null) {
            let hubConnection = new signalR.HubConnectionBuilder()
                .withUrl(ApiUrls.UserNotificationHub,
                    { accessTokenFactory: () => this.props.user?.access_token || '', withCredentials: false })
                .configureLogging(signalR.LogLevel.None)
                .build();

            hubConnection.start().then(a => {

                this.setState({
                    hubConnection: hubConnection
                });
                hubConnection.onclose((error) => {
                    if (error) {
                        setTimeout(() => { this.Reconnect() }, 30000)
                    }

                })
                hubConnection.on("AddNewUserNotificationSend", async (notification: UserNotification) => {
                    if (notification.isImportant) {
                        await this.props.AddImportantNotificationAction(notification)
                    }

                });

            })
                .catch(error => {

                });

        }
    }

    private Reconnect() {
        if (this.state.hubConnection) {
            this.state.hubConnection.start().catch(() => {
                setTimeout(() => { this.Reconnect() }, 30000)
            });
        }
    }



    public render() {

        return (
            <React.Fragment>
                {this.props.isExistsImportant &&
                    <UserImportantNotification
                        notification={this.props.importantNotifications.find(item => item.isImportant)}
                        ReadImportantNotification={(notification) => { this.props.ReadImportantNotificationAction(notification.id) }}
                    >
                    </UserImportantNotification>
                }

            </React.Fragment>
        );
    }
}


export default connect(
    (state: ApplicationState) => ({ ...state.userNotification, ...state.user }),
    dispatchAction
)(UserNotificationContainer as any);